import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "./Reveal";

const BENEFITS = [
    { title: "Build Customer Trust", desc: "Let customers see your real space before they visit." },
    { title: "Increase Engagement", desc: "Give visitors an interactive experience instead of static images." },
    { title: "Stand Out Online", desc: "Present your business with a modern and memorable digital experience." },
    { title: "Help Customers Decide", desc: "Show your facilities, atmosphere and environment before the customer visits." },
    { title: "Share Everywhere", desc: "Use your virtual tour on your website, Google, WhatsApp, social media and QR codes." },
    { title: "Premium Brand Image", desc: "Make your business look professional, modern and technology-driven." },
];

export default function Benefits() {
    return (
        <section className="relative py-20 lg:py-32" data-testid="benefits-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHead
                    chapter="05"
                    eyebrow="Why It Works"
                    title="WHY CHOOSE A 360° EXPERIENCE?"
                    sub="Curiosity becomes confidence — and confidence walks through your door."
                />
                <div className="mt-14 divide-y divide-[#00C6FF]/12 border-y border-[#00C6FF]/12">
                    {BENEFITS.map((b, i) => (
                        <motion.div
                            key={b.title}
                            data-testid={`benefit-row-${i}`}
                            initial={{ opacity: 0, x: -32 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                            className="group grid items-center gap-3 py-7 transition-colors duration-300 hover:bg-[#0A1F44]/35 sm:grid-cols-[80px_1fr_1.4fr_40px] sm:gap-6 sm:px-4"
                        >
                            <span className="font-mono-accent text-2xl font-bold text-[#00C6FF]/35 transition-colors group-hover:text-[#00C6FF]">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <h3 className="text-xl font-semibold text-white sm:text-2xl">
                                {b.title}
                            </h3>
                            <p className="text-sm text-slate-400 sm:text-base">{b.desc}</p>
                            <ArrowUpRight
                                size={22}
                                className="hidden text-[#00C6FF] opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100 sm:block"
                            />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
